import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useWritable } from '../../app/MeContext';
import { useScreen } from '../../app/shell-context';
import { pluralWithCount } from '../../lib/plural';
import { ChevronIcon } from '../../ui/icons';
import { Pill } from '../../ui/parts';
import { FormSkeleton, LoadFailed } from '../org-parts';
import { useAdminSettings } from '../api';

/**
 * Раздел «Адреса»: список и переход в карточку.
 *
 * Кнопки сохранения здесь нет и быть не должно. Адрес — отдельная запись со
 * своими ручками (`POST/PATCH/DELETE /api/admin/locations`), он создаётся и
 * удаляется сразу; привязать это к кнопке карточки организации значило бы
 * обещать откат, которого нет.
 */
export function OrgAddresses() {
  const writable = useWritable();
  const navigate = useNavigate();
  const data = useAdminSettings();

  useScreen('Адреса', null);

  if (data.isError) {
    return <Screen><LoadFailed busy={data.isFetching} onRetry={() => void data.refetch()} /></Screen>;
  }
  if (!data.data) {
    return (
      <Screen>
        <FormSkeleton rows={3} />
      </Screen>
    );
  }

  const { locations } = data.data;

  return (
    <Screen>
      {/* Слово «Адреса» уже стоит в шапке экрана — здесь только счётчик и смысл. */}
      <p className="lead">
        {pluralWithCount(locations.length, 'адрес', 'адреса', 'адресов')}.
        {' '}Куда приходить клиенту; основной подставляется очным услугам.
      </p>

      {locations.length ? (
        <div className="rows">
          {locations.map((l) => (
            <button className="rw" key={l.id} onClick={() => navigate(`/admin/org/address/${l.id}`)}>
              <span className="rw-body">
                <b>{l.title}</b>
                {/* Адрес показываем целиком: обрезанный по двум строкам, он терял
                    номер дома — ровно то, ради чего его читают. */}
                <span>{l.address}</span>
              </span>
              {l.is_primary ? <Pill kind="paid">основной</Pill> : null}
              <span className="chev"><ChevronIcon /></span>
            </button>
          ))}
        </div>
      ) : (
        <p className="lead">Ни одного адреса — клиент не увидит, куда идти.</p>
      )}

      {writable ? (
        <button className="add" onClick={() => navigate('/admin/org/address/new')}>＋ Добавить адрес</button>
      ) : null}
    </Screen>
  );
}
